import React, { Component } from 'react';
import './A2.css';

class A2 extends Component{
    render(){
        return(    
        <div className="campoA2">{this.props.children}
        </div>
        )
    }

}

export default A2;